import { useSignoffs } from '../signoff/useSignoffs';
import { Link } from 'react-router-dom';
import { useApp } from '../../lib/app';
import { DRIVER_FEATURES } from '../nav/features';
import { Tile } from '../nav/Tile';
import { useInbox } from '../messages/useMessages';

/** Driver home: one tile per thing a driver does. Tiles light up as each phase lands. */
export function HomeView() {
  const app = useApp();
  const signoffs = useSignoffs();
  const unread = (useInbox() ?? []).filter((m) => !m.read);
  const first = app.userName.split(' ')[0];
  const terminal = app.multiTerminal && app.terminal !== 'all' ? app.terminals.find((t) => t.id === app.terminal)?.name : null;
  return (
    <div>
      <div className="card card-hero">
        <h2 style={{ fontSize: 20, margin: 0 }}>Hi{first && first !== 'You' ? `, ${first}` : ''}</h2>
        <div className="small" style={{ opacity: 0.85 }}>{app.details.name}{terminal ? ` · ${terminal}` : ''}</div>
      </div>
      {signoffs?.remind && (
        <Link to="/signoff" className="card row settings-link" style={{ borderColor: 'rgba(245,166,35,.5)', justifyContent: 'space-between' }}>
          <span className="grow"><strong>Sign the {signoffs.pending.consents[0]?.title || 'camera & biometric consent'}</strong><br /><span className="muted small">Managers sign it too — your drivers can't use the app until they do.</span></span>
          <span aria-hidden>›</span>
        </Link>
      )}
      {unread.length > 0 && (
        <Link to={unread.length === 1 ? `/messages/${unread[0]!.b.id}` : '/messages'} className="card row settings-link" style={{ borderColor: 'var(--accent)', justifyContent: 'space-between' }}>
          <span className="grow"><strong>💬 {unread.length === 1 ? 'New message' : `${unread.length} new messages`}</strong><br /><span className="muted small">{unread[0]!.b.title}</span></span>
          <span aria-hidden>›</span>
        </Link>
      )}
      <div className="tile-grid">
        {DRIVER_FEATURES.filter((f) => f.id !== 'bonus' || app.settings['bonuses'] === true).map((f) => <Tile key={f.id} f={f} />)}
      </div>
    </div>
  );
}
